// Menu ancré via [data-menu="#id"]
document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-menu]');
    const openMenus = document.querySelectorAll('.menu-open');
    if (btn) {
        const id = btn.getAttribute('data-menu');
        const anchor = document.querySelector(id);
        if (anchor) {
            openMenus.forEach(m => m !== anchor && m.classList.remove('menu-open'));
            anchor.classList.toggle('menu-open');
        }
    } else if (!e.target.closest('.menu-surface')) {
        openMenus.forEach(m => m.classList.remove('menu-open'));
    }
});
